// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__ufcM3","cover":"Intro_cover__NVJ+H"};